import { form } from 'formifier';

const mqErrorMessages = {
  Name: {
    valueMissing: 'Please enter your first and last name.',
    tooLong: 'Please enter 120 characters or less for your first name.'
  },
  Email: {
    valueMissing: 'Please enter your email address.',
    patternMismatch: 'Please enter a valid email address.',
    tooLong: 'Please enter 80 characters or less for your email address.'
  },
  Phone: {
    valueMissing: 'Please enter your phone number.',
    patternMismatch: 'Please enter a valid phone number.',
    tooLong: 'Please enter 25 characters or less for the phone number.'
  },
  Age: {
    patternMismatch: 'Please enter a valid number.'
  },
  Career: {
    tooLong: 'Please enter 255 characters or less for career.'
  },
  NetWorth: {
    tooLong: 'Please enter 100 characters or less for net worth.'
  },
  MixOfWealth: {
    tooLong: 'Please enter 255 characters or less for mix of wealth.'
  },
  Income: {
    tooLong: 'Please enter 100 characters or less for income.'
  },
  Inherited: {
    tooLong: 'Please enter 100 characters or less for inherited.'
  },
  HowMuchDebt: {
    tooLong: 'Please enter 100 characters or less for debt.'
  },
  Giving: {
    tooLong: 'Please enter 255 characters or less for giving.'
  },
  Degree: {
    tooLong: 'Please enter 255 characters or less for degree.'
  },
  GPA: {
    tooLong: 'Please enter 5 characters or less for GPA.'
  },
  Jeans: {
    tooLong: 'Please enter 100 characters or less for jeans.'
  },
  NewCars: {
    tooLong: 'Please enter 120 characters or less for new cars.'
  },
  Books: {
    tooLong: 'Please enter 25 characters or less for books per month.'
  },
  Advice: {
    tooLong: 'Please enter 500 characters or less for advice.'
  },
  Terms: {
    valueMissing: 'You must agree to the terms before you can submit.'
  }
};

form(
  mqErrorMessages,
  document.getElementById('millionaire-questionnaire-form')
);
